import * as cookieMonster from 'cookie';
import { Cookie } from './types';

export function getCookieValue(cookie: Cookie, cookieKey: string): string | null {
    const parsed = typeof cookie === 'string' ? cookieMonster.parse(cookie) : cookie;
    return (parsed && parsed[cookieKey]) || null;
}
